import api from '../axios'


export default {
  login: (payload) => api.post('/staff/login', payload),
  logout: () => api.put('/staff/logout'),
  getCurrentUser: () => api.get('/admin/staff/get-current'),
  getPermissions: () => api.get('/admin/staff/get-current-permissions'),
  verify2FA: (payload, staff_id) => api.put(`/admin/2fa/${staff_id}/validate-2fa`, payload),
}
